import { connect } from 'react-redux'
import TripFeedbackTabelPane from '../../components/trip-feedbacks/TripFeedbackTablePane'
import { actionCreators } from '../../state/actions/trips'
import { IStoreState, ITripFilters } from '../../types/index'
import { fetchProductsByOrganizationId } from '../../state/actions/provider-products'
import { fetchServiceList } from '../../state/actions/services'
import { SERVICE_LIST_TYPE } from '../../state/constants/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    routeProps: ownProps,
    orgId: state.organizations.currentOrgId,
    filters: state.trips.filters,
    services: Object.values(state.service.items)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: (organizationId: string, type: string) => {
      dispatch(
        fetchProductsByOrganizationId({
          organizationId,
          skip: 0,
          take: 9999, // get all existing products
          active: type === 'active',
          orderBy: 'providers_products.name',
          sort: 'DESC'
        })
      )
      dispatch(fetchServiceList(SERVICE_LIST_TYPE.ACTIVE, organizationId, 'services.name', 'ASC'))
    },
    updateTripFilters: (params: ITripFilters) => dispatch(actionCreators.feedbackFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripFeedbackTabelPane)



// WEBPACK FOOTER //
// ./src/containers/trip-feedbacks/TripFeedbackTablePane.ts